import React from 'react';

import Grid from '@mui/material/Grid';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import airbnb from 'src/App/assets/airbnbMini.svg';
import { UserListingInfoBar } from 'src/App/Dashboards/Market/Components';
import {
  COLOR_PRIMARY,
  COLOR_RED,
  COLOR_TOOLTIP_BACKGROUND,
  MID_GREY,
  SAMPLE_LISTING_ID,
} from 'src/utils/const';
import { Listing, ListingLegacy } from 'src/interfaces/idashboard';
import { Alert, Box, Button, Card, CardContent, Chip, Typography } from '@mui/material';
import {
  COLOR_ERROR_1,
  COLOR_ERROR_BACKGROUNG,
  COLOR_PRIMARY_1,
  COLOR_SUCCESS_1,
  COLOR_SUCCESS_BACKGROUNG,
  COLOR_TERTIARY_1_100,
  COLOR_TERTIARY_1_800,
} from 'src/utils/colors';
import { SelecFilterChip } from 'src/App/Dashboards/Market/Components/Chips';
import { isDateBeforeFourWeeks, isMoreThanNDaysAgo } from 'src/utils/functions';
import { RecentlyAddedChip } from 'src/App/Dashboards/Market/Components/Chips/RecentlyAddedChip';
import ListingInactivityChip from 'src/App/Dashboards/Market/Components/Chips/ListingInactivityChip';
import UnlistedChip from 'src/App/Dashboards/Market/Components/Chips/UnlistedChip';

const TopBar = ({
  onClose,
  isMobileScreen,
  data,
  title,
  isCompListing,
  noListingData,
  isListingRecentlyAdded,
  isListingInactive,
  isListingUnlisted,
  userSubscriptionPlan,
  noSampleListingOption
}: {
  onClose;
  isMobileScreen: boolean;
  data: any[] | Listing;
  title: string;
  isCompListing?: boolean;
  noListingData?: boolean;
  isListingRecentlyAdded: boolean;
  isListingInactive: boolean;
  isListingUnlisted: boolean;
  userSubscriptionPlan: string;
  noSampleListingOption?: boolean;
}) => {
  return (
    <>
      <Grid
        container
        wrap="nowrap"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        sx={{ py: 2, ...(isMobileScreen ? { ml: 0 } : {}) }}
      >
        <Grid item xs={12} md={7}>
          {!noListingData && (
            <>
              {isListingRecentlyAdded && (
                <span style={{ marginRight: '10px' }}>
                  <RecentlyAddedChip noShadow={true} />
                </span>
              )}
              {isListingInactive && (
                <span style={{ marginRight: '10px' }}>
                  <ListingInactivityChip
                    activeDaysCount={data['activeDaysCount']}
                    noShadow={true}
                  />
                </span>
              )}
              {isListingUnlisted && (
                <span style={{ marginRight: '10px' }}>
                  <UnlistedChip noShadow={true} />
                </span>
              )}
            </>
          )}
          {!noListingData && (
            <Typography
              variant="h6"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-word',
                ...(isMobileScreen
                  ? {
                      fontSize: '1rem',
                      lineHeight: '1.4',
                    }
                  : {}),
              }}
            >
              {title}
            </Typography>
          )}
        </Grid>

        {/* Close icon on the far right */}
        <Grid item container xs={12} md={5} justifyContent={'flex-end'}>
          {/* TODO FOR FREE USERS */}
          {userSubscriptionPlan === 'starter' && !noSampleListingOption && (
            <Button
              variant="contained"
              onClick={() => {
                window.location.href = `/listing/${SAMPLE_LISTING_ID}`;
              }}
              sx={{
                mr: '10px',
                color: COLOR_PRIMARY,
                background: '#fff',
                '&:hover': {
                  color: '#fff',
                },
              }}
            >
              View Sample Listing
            </Button>
          )}
          <CloseRoundedIcon
            sx={{ cursor: 'pointer', color: COLOR_RED, fontSize: 40 }}
            onClick={onClose}
          />
        </Grid>
      </Grid>

      <Grid container wrap="nowrap" spacing={2} alignItems="center" sx={{ py: 2 }}>
        {isCompListing && !noListingData && (
            <Grid item xs={isMobileScreen ? 12 : 2}>
              <UserListingInfoBar listing={data} />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default TopBar;
